import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleFax } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

export const PrintForm = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      alignItems='center'
      width='max-content'
      sx={{ ':hover': { cursor: 'pointer', textDecoration: 'underline' } }}
      onClick={() => {
        window.print();
      }}
      onKeyDown={(event) => onEnterOrEscapeKeyDown(event)}
      tabIndex={0}
      aria-label={
        Dictionary[DICTIONARY.CompassRights].compassRightsHeader.printForm
      }
    >
      <Avatar src={PurpleFax} alt={''} sx={{ width: '24px', height: '24px' }} />
      <Typography
        variant={'body7'}
        color={'primary.main'}
        maxWidth={isDesktop ? 'initial' : '40px'}
      >
        {Dictionary[DICTIONARY.CompassRights].compassRightsHeader.printForm}
      </Typography>
    </Stack>
  );
};
